import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faRightFromBracket,
  faTicket,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import ThirdPartyLogoutPopup from "../../DashBaord/ThirdPartyLogoutPopup";
import "../winningVouchers.css";

const AgentNavbar = ({ title = "Assigned Vouchers" }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("AGENT-ADMIN-INFO") || "{}");

  useEffect(() => {
    const handleScroll = () => setSticky(window.scrollY > 8);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const closeMenu = () => setMenuOpen(false);
    if (menuOpen) {
      document.addEventListener("click", closeMenu);
      return () => document.removeEventListener("click", closeMenu);
    }
  }, [menuOpen]);

  const displayName =
    user?.name || user?.email?.split("@")?.[0] || "Agent";

  return (
    <>
      <header className={`agent-navbar ${isSticky ? "agent-navbar--sticky" : ""}`}>
        <div className="agent-navbar__inner">
          <div className="agent-navbar__brand">
            <img
              src="/logo.png"
              alt="Crown King"
              className="agent-navbar__logo"
            />
            <div className="agent-navbar__titles">
              <span className="agent-navbar__app">Crown King Agent</span>
              <h1 className="agent-navbar__page">{title}</h1>
            </div>
          </div>

          <div className="agent-navbar__actions">
            <div className="agent-navbar__user d-none d-md-flex">
              <FontAwesomeIcon icon={faUser} />
              <span>{displayName}</span>
            </div>

            <button
              type="button"
              className="agent-navbar__menu-btn d-md-none"
              aria-label="Open menu"
              onClick={(e) => {
                e.stopPropagation();
                setMenuOpen((v) => !v);
              }}
            >
              <FontAwesomeIcon icon={faBars} />
            </button>

            <button
              type="button"
              className="agent-navbar__logout-btn d-none d-md-inline-flex"
              onClick={() => setPopUpOpen(true)}
            >
              <FontAwesomeIcon icon={faRightFromBracket} />
              Logout
            </button>
          </div>
        </div>

        {menuOpen && (
          <div
            className="agent-navbar__dropdown"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="agent-navbar__dropdown-user">
              <FontAwesomeIcon icon={faUser} />
              <span>{displayName}</span>
            </div>
            <button
              type="button"
              className="agent-navbar__dropdown-item"
              onClick={() => {
                setMenuOpen(false);
                navigate("/voucher-list");
              }}
            >
              <FontAwesomeIcon icon={faTicket} />
              Voucher List
            </button>
            <button
              type="button"
              className="agent-navbar__dropdown-item agent-navbar__dropdown-item--danger"
              onClick={() => {
                setMenuOpen(false);
                setPopUpOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faRightFromBracket} />
              Logout
            </button>
          </div>
        )}
      </header>

      <ThirdPartyLogoutPopup
        popUpOpen={popUpOpen}
        togglePopUp={() => setPopUpOpen(!popUpOpen)}
      />
    </>
  );
};

export default AgentNavbar;
